var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"src":'http://ceditor.kjt61.com' + '?t=' + (new Date()).getTime()}})])}
var staticRenderFns = []

export { render, staticRenderFns }